module.exports = "<carousel>\r\n\t<slide *ngFor=\"let image of images\">\r\n\t\t<img src=\"{{image}}\" />\r\n\t</slide>\r\n</carousel>\r\n"


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/app/components/technology/technology-carousel/technology-carousel.component.html
// module id = ./Frontend/src/app/components/technology/technology-carousel/technology-carousel.component.html
// module chunks = main